import React, { useContext, useEffect, useState, useRef } from 'react';
import { Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { converHtml, getInfo, sendRequest } from '../services/infoService';
import withReactContent from 'sweetalert2-react-content';
import { FaChevronLeft, FaSave } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router';
import EditorComponent from './EditorComponent';
import { AppContext } from '../AppContext';
import '../assets/css/Vinculos.css';
import Swal from 'sweetalert2'
import _ from 'lodash';
import { API_BASE_URL } from '../config/api';
import axios from 'axios';
import { PROFILES } from '../const';

const MySwal = withReactContent(Swal)

interface Vinculo {
  contenido: any;
  seccion: any;
  seccion_destacada: any;
  id: string;
  id_seccion: string;
  titulo: string;
  vinculo_rapido: string;
  vinculo_publico: string;
  id_tipo_perfil: string;
  pdf_url?: string;
  pdf_folder?: string;
  pdf_name?: string;
  miniatura_url?: string;
  miniatura_folder?: string;
  miniatura_name?: string;
}

interface Seccion {
  id_seccion: string;
  seccion: string;
}

const Vinculos: React.FC = () => {
  const context = useContext(AppContext);
  const { id, seccion } = useParams<{ id: string; seccion: string }>();

  const navigation = useNavigate();

  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploadingMiniatura, setIsUploadingMiniatura] = useState(false);

  const localData = localStorage.getItem("data");
  const localDataParsed = JSON.parse(localData || '{}');

  const [vinculos, setVinculos] = useState<Vinculo[]>((context?.data?.vinculos?.length > 0) ? context?.data.vinculos : localDataParsed?.vinculos || []);
  const [vinculo, setVinculo] = useState<Vinculo>({
    contenido: '',
    seccion: '',
    seccion_destacada: '',
    id: 'new',
    id_seccion: '',
    titulo: '',
    vinculo_rapido: '',
    vinculo_publico: '',
    id_tipo_perfil: ''
  });
  const [secciones] = useState<Seccion[]>((context?.data?.secciones?.length > 0) ? context?.data.secciones : localDataParsed?.secciones || []);

  const [selectedSeccion, setSelectedSeccion] = useState('');
  const [selectedRapido, setSelectedRapido] = useState('');
  const [selectedPublico, setSelectedPublico] = useState('');
  const [selectedProfile, setSelectedProfile] = useState('');
  const [content, setContent] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [miniaturaUrl, setMiniaturaUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [dataOld, setDataOld] = useState<Vinculo | null>(null);

  const isSoporte = true;

  const isFetching = useRef<string | null>(null);

  useEffect(() => {
    if (!id || vinculos.length === 0) {
      setLoading(false);
      return;
    }

    const currentVinculo = vinculos.find((element) => Number(element.id) === Number(id));

    console.log('currentVinculo', currentVinculo);

    if (currentVinculo) {
      setVinculo(currentVinculo);

      if (!currentVinculo.contenido && currentVinculo.contenido !== "" && isFetching.current !== id && currentVinculo.id) {
        isFetching.current = id;

        let formData = new FormData();
        formData.append("idContenido", currentVinculo.id);

        fetch(`${API_BASE_URL}/cliente.php`, {
          method: "POST",
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            let contentHtml = converHtml(data.resp);
            setContent(contentHtml);
            setPdfUrl(data.pdf_url || '');
            setMiniaturaUrl(data.miniatura_url || '');

            const updatedVinculo = { ...currentVinculo, contenido: contentHtml, pdf_url: data.pdf_url || '', miniatura_url: data.miniatura_url || '', pdf_folder: data.pdf_folder || '', pdf_name: data.pdf_name || '', miniatura_folder: data.miniatura_folder || '', miniatura_name: data.miniatura_name || '' };
            setVinculo(updatedVinculo);

            const updatedVinculos = vinculos.map(v => v.id === updatedVinculo.id ? updatedVinculo : v);
            setVinculos(updatedVinculos);
            setDataOld(updatedVinculo);
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              icon: 'error',
              title: 'Error al cargar el contenido',
              text: 'Ha ocurrido un error al cargar el contenido del vínculo',
            });
          })
          .finally(() => {
            setLoading(false);
            isFetching.current = null;
          });
        return;
      }

      if (currentVinculo.contenido || currentVinculo.contenido === "") {
        setContent(currentVinculo.contenido);
        setPdfUrl(currentVinculo.pdf_url || '');
        setLoading(false);
      }
      return;
    }

    setLoading(false);
  }, [id, vinculos, seccion]);

  useEffect(() => {
    if (vinculo) {
      setSelectedSeccion(seccion || vinculo.id_seccion || '');
      setSelectedRapido(vinculo.vinculo_rapido || '');
      setSelectedPublico(vinculo.vinculo_publico || '');
      setSelectedProfile(vinculo.id_tipo_perfil || '');
    }
  }, [vinculo, seccion]);

  const handleChange = (event: any) => {
    setSelectedSeccion(event.target.value);
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVinculo({ ...vinculo, titulo: event.target.value });
  };

  const handleFastChange = (event: any) => {
    setSelectedRapido(event.target.value);
  }

  const handlePublicChange = (event: any) => {
    setSelectedPublico(event.target.value);
  }

  const handleEditorChange = (content: string) => {
    setContent(content);
  };

  const handleMiniaturaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      uploadMiniatura(file);
    }
  };

  const handlePdfChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    // todo validar tipo de archivo y tamaño
    if (!file) return;

    if (file) {
      uploadPdf(file);
    }
  };

  const uploadMiniatura = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tipo', 'imagen');

    setIsUploadingMiniatura(true);
    setProgress(0);

    try {
      const response = await axios.post(API_BASE_URL + "/upload.php", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const total = progressEvent.total;
          const current = progressEvent.loaded;

          if (total) {
            const percentage = Math.round((current * 100) / total);
            setProgress(percentage);
          }
        },
      });

      Swal.fire({
        icon: 'success',
        title: 'Miniatura subida',
        text: 'La miniatura se ha subido correctamente',
      });

      const miniaturaUrl = response.data.url;
      setMiniaturaUrl(miniaturaUrl);

    } catch (error) {
      console.error('Error al subir la miniatura:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo subir la miniatura',
      });
    } finally {
      setIsUploadingMiniatura(false);
    }
  };

  const uploadPdf = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tipo', 'documento');

    setIsUploading(true);
    setProgress(0);

    try {
      const response = await axios.post(API_BASE_URL + "/upload.php", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const total = progressEvent.total;
          const current = progressEvent.loaded;
          if (total) {
            const percentage = Math.round((current * 100) / total);
            setProgress(percentage);
          }
        },
      });

      Swal.fire({
        icon: 'success',
        title: 'PDF subido',
        text: 'El PDF se ha subido correctamente',
      });

      setPdfUrl(response.data.url);
    } catch (error) {
      console.error('Error al subir el PDF:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo subir el PDF',
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handleSave = () => {
    if (vinculo) {
      const updatedVinculo = { ...vinculo, contenido: content, id_seccion: selectedSeccion, vinculo_rapido: selectedRapido, vinculo_publico: selectedPublico, id_tipo_perfil: selectedProfile, pdf_url: pdfUrl, miniatura_url: miniaturaUrl, pdf_folder: vinculo.pdf_folder || '', pdf_name: vinculo.pdf_name || '', miniatura_folder: vinculo.miniatura_folder || '', miniatura_name: vinculo.miniatura_name || '' };

      const isEqual = _.isEqual(updatedVinculo, dataOld);

      if (isEqual) {
        Swal.fire({
          icon: 'info',
          title: 'Sin cambios',
          text: 'No se han realizado cambios en el contenido',
        });
        return;
      }

      const formData = new FormData();
      formData.append("guardar_vinculo", "true");
      formData.append("id", updatedVinculo.id);
      formData.append("id_seccion", updatedVinculo.id_seccion);
      formData.append("titulo", updatedVinculo.titulo);
      formData.append("vinculo_rapido", updatedVinculo.vinculo_rapido);
      formData.append("vinculo_publico", updatedVinculo.vinculo_publico);
      formData.append("contenido", updatedVinculo.contenido);
      formData.append("id_tipo_perfil", updatedVinculo.id_tipo_perfil);
      formData.append("pdf_url", pdfUrl);
      formData.append("miniatura_url", miniaturaUrl);
      formData.append("pdf_folder", updatedVinculo.pdf_folder || '');
      formData.append("pdf_name", updatedVinculo.pdf_name || '');
      formData.append("miniatura_folder", updatedVinculo.miniatura_folder || '');
      formData.append("miniatura_name", updatedVinculo.miniatura_name || '');

      setLoading(true);

      sendRequest(formData).then(async () => {
        await getInfo(context, localStorage.getItem("hash"), context?.plataforma);
        setLoading(false);
        MySwal.fire({
          icon: 'success',
          title: 'Vínculo actualizado',
          text: 'El vínculo ha sido actualizado correctamente',
        });
        setDataOld(updatedVinculo);
      }).catch((error) => {
        console.error(error);
        setLoading(false);
        MySwal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ha ocurrido un error al actualizar el vínculo',
        });
      });
    }
  };

  const goBack = () => {
    const updatedVinculo = { ...vinculo, contenido: content, id_seccion: selectedSeccion, vinculo_rapido: selectedRapido, vinculo_publico: selectedPublico, id_tipo_perfil: selectedProfile, pdf_url: pdfUrl, miniatura_url: miniaturaUrl, pdf_folder: vinculo.pdf_folder || '', pdf_name: vinculo.pdf_name || '', miniatura_folder: vinculo.miniatura_folder || '', miniatura_name: vinculo.miniatura_name || '' };

    const isEqual = _.isEqual(updatedVinculo, dataOld);
    if (!isEqual) {
      MySwal.fire({
        title: '¿Desea salir sin guardar los cambios?',
        text: "Los cambios realizados no se guardarán.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, salir',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          navigation(-1);
        }
      });
    } else {
      navigation(-1);
    }
  };

  return (
    <div className="vinculos-container xl:px-16 2xl:px-20">
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="view">
            <div className="migas flex justify-between items-center">
              <div className="items-center gap-2 hidden lg:block">
                <Button onClick={() => goBack()} className="!rounded-3xl" >
                  <FaChevronLeft className="i" style={{ marginRight: '5px' }} />
                  Volver
                </Button>
              </div>
              <div className="flex gap-2 lg:hidden">
                <Button variant="text" className="!rounded-3xl sm:hidden " onClick={() => goBack()} title='volver'>
                  <FaChevronLeft className="i" />
                </Button>
              </div>
              <h2>{id === 'new' ? 'Crear Vínculo' : `Editar Vínculo`}</h2>
              <div className="items-center gap-2 hidden lg:block">
                <Button variant="contained" className="!rounded-3xl" onClick={handleSave}>
                  Guardar
                  <FaSave className="i" style={{ marginLeft: '5px' }} />
                </Button>
              </div>
              <div className="flex gap-2 lg:hidden">
                <Button variant="contained" className="!rounded-3xl sm:hidden " onClick={handleSave}  >
                  <FaSave className="i" />
                </Button>
              </div>
            </div>
          </div>

          <div className="vinculos" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <FormControl fullWidth>
                <InputLabel id="Sección">Sección</InputLabel>
                <Select
                  labelId="Sección"
                  id="select"
                  value={selectedSeccion}
                  label="Sección"
                  onChange={handleChange}
                >
                  {secciones.map((seccion) => (
                    <MenuItem key={seccion.id_seccion} value={seccion.id_seccion}>{seccion.seccion}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField id="titulo" label="Titulo" variant="outlined" value={vinculo?.titulo || ''} fullWidth onChange={handleTitleChange} />
            </div>
            <div>
              <InputLabel id="pdf-file">Miniatura (opcional)</InputLabel>
              <input type="file" onChange={handleMiniaturaChange} accept="image/*" />
              {miniaturaUrl && (
                <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <a href={miniaturaUrl} target="_blank" rel="noopener noreferrer" className="text-primary">
                    Ver miniatura actual
                  </a>
                  <button
                    type="button"
                    onClick={() => {
                      const miniatura__folder = miniaturaUrl.split('/').slice(-2, -1)[0];
                      const miniatura__name = miniaturaUrl.split('/').slice(-1)[0];
                      setMiniaturaUrl('')
                      setVinculo({ ...vinculo, miniatura_url: '', miniatura_folder: miniatura__folder, miniatura_name: miniatura__name })
                    }}
                    className="text-red-500 text-sm border-none bg-transparent cursor-pointer"
                  >
                    Quitar
                  </button>
                </div>
              )}
              {isUploadingMiniatura && (
                <div style={{ marginTop: '20px' }}>
                  <progress value={progress} max="100" style={{ width: '100%', height: '20px' }} />
                  <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{progress}% cargado</p>
                </div>
              )}
            </div>
            <div>
              <FormControl fullWidth className="rounded-3xl">
                <InputLabel id="vinculo-rapido">¿Vinculo rápido?</InputLabel>
                <Select
                  labelId="vinculo-rapido"
                  id="vinculo-rapido"
                  value={selectedRapido}
                  label="¿Vinculo rápido?"
                  onChange={handleFastChange}
                >
                  <MenuItem value={"TRUE"}>Si</MenuItem>
                  <MenuItem value={"FALSE"}>No</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl fullWidth className="rounded-3xl">
                <InputLabel id="vinculo-publico">¿Vinculo público?</InputLabel>
                <Select
                  labelId="vinculo-publico"
                  id="vinculo-publico"
                  value={selectedPublico}
                  label="¿Vinculo público?"
                  onChange={handlePublicChange}
                >
                  <MenuItem value={"TRUE"}>Si</MenuItem>
                  <MenuItem value={"FALSE"}>No</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl fullWidth>
                <InputLabel id="Perfil">Perfil</InputLabel>
                <Select
                  labelId="Perfil"
                  id="select-profile"
                  value={selectedProfile}
                  label="Perfil"
                  onChange={(event) => setSelectedProfile(event.target.value)}
                >
                  {PROFILES.map((perfil) => (
                    <MenuItem key={perfil.id} value={perfil.id}>{perfil.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <InputLabel id="pdf-file">Documento PDF (opcional)</InputLabel>
              <input type="file" onChange={handlePdfChange} accept=".pdf,application/pdf" />
              {pdfUrl && (
                <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="text-primary">
                    Ver PDF actual
                  </a>
                  <button
                    type="button"
                    onClick={() => {
                      const pdf__folder = pdfUrl.split('/').slice(-2, -1)[0];
                      const pdf__name = pdfUrl.split('/').slice(-1)[0];
                      setPdfUrl('')
                      setVinculo({ ...vinculo, pdf_url: '', pdf_folder: pdf__folder, pdf_name: pdf__name })
                    }}
                    className="text-red-500 text-sm border-none bg-transparent cursor-pointer"
                  >
                    Quitar
                  </button>
                </div>
              )}
              {isUploading && (
                <div style={{ marginTop: '20px' }}>
                  <progress value={progress} max="100" style={{ width: '100%', height: '20px' }} />
                  <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{progress}% cargado</p>
                </div>
              )}
            </div>
            <div>
              <h3>Contenido</h3>
              <EditorComponent
                isSoporte={isSoporte}
                options={[
                  'bold', 'italic', 'underline', 'strikeThrough',
                  'insertOrderedList', 'insertUnorderedList',
                  'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
                  'insertVideo', 'createLink', 'unlink', 'insertImage', 'removeFormat'
                ]}
                value={content}
                onChange={handleEditorChange}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Vinculos;
